import { useGetClientInformation } from './index';
import { Portals } from '../../../types';

export const useIsBTobEnabled = () => {
  const { clientInformation } = useGetClientInformation();

  return clientInformation?.enablePortals?.includes(Portals.BTOB);
};
